module.exports = __webpack_public_path__ + "media/images/stop_sign-34f6aa91a34258ed612124251df98c60.png";